import { Injectable }    from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { isDevMode } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export class AuthenticationService {
    constructor(private http: HttpClient) {}

    signinByUsernamePassword(username: string, password: string): Observable<any> {
        let url: string = environment.serviceUrl + 'login';
        if(isDevMode()) {
            url = environment.proxyUrl + '?url=' + url;
        }
        return this.http.post(url, {
            username: username,
            password: password,
            client_id: environment.client_id,
            client_secret: environment.client_secret,
            grant_type: 'password'
        });
    }

    getRefreshToken(): Observable<any> {
        var userInfo = localStorage.getItem('ls.userInfo');
        if(userInfo) {
            var objUserInfo = JSON.parse(userInfo);
            let url: string = environment.serviceUrl + 'login';
            if(isDevMode()) {
                url = environment.proxyUrl + '?url=' + url;
            }
            return this.http.post(url, {
                username: objUserInfo.username,
                refresh_token: objUserInfo.refreshToken,
                client_id: environment.client_id,
                client_secret: environment.client_secret,
                grant_type: 'refresh_token'
            })
        }
        return null;
    }

    isLoggedIn(): boolean {
        return localStorage.getItem("ls.userInfo") != null;
    }
}


// WEBPACK FOOTER //
// /Users/Anders/workspace/DOFBasenCli/src/app/share/security/authentication.service.ts